import classNames from 'classnames/bind';
import { ReactElement } from 'react';

import Styles from './Radio.module.scss';

const cx = classNames.bind(Styles);

interface Props<T> {
  /** Dictates whether radio input is disabled or not */
  disabled?: boolean;
  /** Radio input value */
  value?: T;
  /** Radio input label */
  label: string | ReactElement;
  /** Radio input id */
  id?: string;
  /** Radio input group name */
  name: string;
  /** Radio input onChange callback (target value is passed into onChange func) */
  onChange: (value: T) => void;
  /**Default selected value */
  isSelected?: boolean;
}

const Radio = <T extends string | number>(props: Props<T>) => {
  const { disabled = false, value, name, label, id, onChange, isSelected, ...otherProps } = props;

  const handleChange = (event) => {
    if (onChange && !disabled) {
      onChange(event.target.value as T);
    }
  };

  return (
    <label className={cx('form-element', 'radio', { 'radio--disabled': disabled })}>
      <input
        type='radio'
        id={id}
        value={value as string | number}
        ref={(el) => {
          el;
        }}
        {...otherProps}
        disabled={disabled}
        name={name}
        className={cx('radio__input', { 'radio__input--disabled': disabled })}
        tabIndex={disabled ? -1 : 0}
        onChange={handleChange}
        checked={isSelected}
      />
      <span className={cx('radio__text')}>{label}</span>
    </label>
  );
};

export default Radio;
